export default __webpack_public_path__ + "static/media/VariablesImg.1d869918.jpg";